import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { BaseModelDto } from '../base/baseModel.dto'
import { ownerOrStaffOnly } from '../base/ownerOrStaffOnly.middleware'
import { presenceOf } from '../base/presenceOf.middleware'
import { PenNameDto } from '../pen-name'
import { bsConstants } from '../../module.constants'
import { CategoryDto } from '../category'

@ObjectType()
export class BookDto extends BaseModelDto {
  @Field({ nullable: true })
  title?: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  penName?: string

  @Field(type => Int, { nullable: true })
  authorPenNameId?: number

  @Field(type => Int, { defaultValue: bsConstants.PEN_NAME.TYPE.MY_BOOK })
  penNameType: number = bsConstants.PEN_NAME.TYPE.MY_BOOK

  @Field(t => PenNameDto, { nullable: true })
  authorPenName?: PenNameDto

  @Field({ nullable: true })
  bookCover?: string

  @Field({ nullable: true })
  releaseDate?: Date

  @Field({ nullable: true })
  seriesName?: string

  @Field(type => Int, { nullable: true })
  seriesNumber?: number

  @Field(t => [CategoryDto], { nullable: true })
  categories?: CategoryDto[]

  @Field({ nullable: true })
  keywords?: string

  @Field(type => Int, { nullable: true })
  wordCount?: number

  @Field(type => Int, { nullable: true })
  audience?: number

  @Field(type => Int, { nullable: true })
  language?: number

  @Field({ nullable: true })
  linkAmazonAsin?: string

  @Field({ nullable: true })
  linkAmazonAsinPrint?: string

  @Field({ nullable: true })
  linkGoodreads?: string

  @Field({ nullable: true })
  linkBookbub?: string

  @Field({ nullable: true })
  linkBarnes?: string

  @Field({ nullable: true })
  linkGoogle?: string

  @Field({ nullable: true })
  linkKobo?: string

  @Field({ nullable: true })
  linkSmashwords?: string

  // Sent only to the book's owner and to staff: a reader who claimed one of its campaigns gets the coupon on
  // their claim instead (ArcClaimDto.smashwordsCouponCode), so it never rides along with a public campaign
  // page - see ownerOrStaffOnly [sc-28919].
  @Field({ nullable: true, middleware: [ownerOrStaffOnly] })
  smashwordsCouponCode?: string

  @Field({ nullable: true })
  linkITunes?: string

  @Field({ nullable: true })
  linkAudibleUs?: string

  @Field({ nullable: true })
  linkAudibleUk?: string

  @Field({ nullable: true })
  linkITunesAudio?: string

  @Field({ nullable: true })
  linkBarnesAudio?: string

  @Field({ nullable: true })
  linkGoogleAudio?: string

  @Field({ nullable: true })
  linkGoodreadsAudio?: string

  @Field({ nullable: true })
  linkKoboAudio?: string

  @Field({ nullable: true })
  linkBookbubAudio?: string

  @Field({ nullable: true })
  linkStoryGraph?: string

  @Field({ nullable: true })
  linkStoryGraphAudio?: string

  @Field(type => Float, { nullable: true })
  averageRating?: number

  @Field(type => Int, { nullable: true })
  reviewCount?: number

  @Field()
  isDraft!: boolean

  @Field({ nullable: true })
  lastArcOn?: Date

  @Field(type => Int, { nullable: true })
  newReviewCount?: number

  @Field(type => Int, { nullable: true })
  updatedReviewCount?: number

  @Field(type => Int, { nullable: true })
  importedId?: number

  // The master files' paths are sent only to the book's owner and to staff: the files themselves are public, so
  // the path is all it takes to download a whole book without claiming it. A claimant gets their path on their
  // claim (ArcClaimDto.epubFile/pdfFile), and everyone can ask hasEpubFile/hasPdfFile [sc-28919].
  @Field(type => String, { nullable: true, middleware: [ownerOrStaffOnly] })
  pdfFile?: string

  @Field(t => Boolean, { nullable: true, middleware: [presenceOf('pdfFile')] })
  hasPdfFile?: boolean

  @Field(type => Int, { nullable: true })
  pdfFileSizeBytes?: number

  @Field({ nullable: true })
  pdfSystemGenerated?: boolean

  @Field({ nullable: true })
  pdfFileDate?: Date

  @Field(type => String, { nullable: true, middleware: [ownerOrStaffOnly] })
  epubFile?: string

  @Field(t => Boolean, { nullable: true, middleware: [presenceOf('epubFile')] })
  hasEpubFile?: boolean

  @Field(type => Int, { nullable: true })
  epubFileSizeBytes?: number

  @Field(type => String, { nullable: true })
  epubPreviewFile?: string

  @Field({ nullable: true })
  epubSystemGenerated?: boolean

  @Field({ nullable: true })
  epubFileDate?: Date

  @Field({ nullable: true })
  epubFileFriendlyName?: string

  @Field({ nullable: true })
  pdfFileFriendlyName?: string

  @Field(t => Int, { nullable: true })
  awaitingBookFileFlag?: number

  // TODO: Implement this
  @Field({ nullable: true })
  iTunesDownloadCodes?: string
}
